import React, { ElementRef, forwardRef } from "react"
import { OpenInNew } from "../../icons"
import { AddressDisplay, classNames, formatAddress } from "../../utils"
import { Button, ButtonProps } from "../Button"
import { Link, LinkProps } from "../Link"
import { Text } from "../Text"

type AddressCalloutLinkComponentProps = Partial<Pick<LinkProps, "href">> &
  Omit<LinkProps, "href">

export type AddressCalloutRenderLinkComponent =
  React.ComponentType<AddressCalloutLinkComponentProps>

export type AddressCalloutProps = {
  address: string
  href?: string
  display?: AddressDisplay
  renderLink?: AddressCalloutRenderLinkComponent
} & ButtonProps

export const AddressCallout = forwardRef<
  ElementRef<typeof Button>,
  AddressCalloutProps
>(function AddressCallout(
  { address, display = "standard", className, renderLink, href, ...rest },
  ref,
) {
  const contents = (
    <Button
      className={classNames("gap-3", !href && "pointer-events-none", className)}
      ref={ref}
      size="sm"
      variant="secondary"
      {...rest}
    >
      <Text>{formatAddress(address, { display })}</Text>
      {href && <OpenInNew size={14} />}
    </Button>
  )

  if (href) {
    const LinkComp = renderLink ?? Link

    return (
      <LinkComp
        className={classNames(!href && "cursor-default")}
        href={href}
        target="_blank"
        variant="unstyled"
      >
        {contents}
      </LinkComp>
    )
  }

  return contents
})
